import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';

import { LocalStorageService } from './local-storage';
import { HttpAPIService } from './httpAPIservice';

import { ENV } from '@app/env';

@Injectable()
export class ApiService extends HttpAPIService {
    private wordpressUrl: string = ENV.wordpressUrl;
    private apiUrl: string = ENV.clientService;
    private notificationUrl: string = ENV.notificationService;

    endpoints: any = {
        authenticate: this.apiUrl + '/auth',
        auditHistory: this.apiUrl + '/auditHistory',
        users: this.apiUrl + '/users',
        divisions: this.apiUrl + '/divisions',
        ropingFormats: this.apiUrl + '/ropingformats',
        organizations: this.apiUrl + '/organizations',
        rodeos: this.apiUrl + '/rodeos',
        reports: this.apiUrl + '/report',
        rodeoEvents: this.apiUrl + '/rodeoEvents',
        notifications: this.apiUrl + '/api/register',
        manage: this.apiUrl + '/manage',
        entries: this.apiUrl + '/rodeoRegistrations',
        horses: this.apiUrl + '/horses',
        images: this.apiUrl + '/images',
        videos: this.apiUrl + '/videos',
        settings: this.apiUrl + '/settings',
        runs: this.apiUrl + '/rodeoEventRuns',
        stock: this.apiUrl + '/stock',
        payment: this.apiUrl + '/payment',
        nominations: this.apiUrl + '/nominations',
        texting: this.notificationUrl + '/notifications',
        notification: this.apiUrl + '/notifications',
        expenseItems: this.apiUrl + '/rodeoExpenseItems',
        memberships: this.apiUrl + '/memberships',
        classifications: this.apiUrl + '/classification',
        team: this.apiUrl + '/team',
        requests: this.apiUrl + '/changeRequest',
        progressions: this.apiUrl + '/progressions',
        
        search: this.apiUrl + '/search',
        timer: this.apiUrl + '/timer',
        judges: this.apiUrl + '/judges',
        pointSeries: this.apiUrl + '/pointSeries',
        payoutconfigpointseries: this.apiUrl + '/payoutconfigpointseries',
        pointStats: this.apiUrl + '/pointstats',
        organizationCheck: this.apiUrl + '/organizationCheckRegister',
        wordpress: this.wordpressUrl,
        accountGroups: this.apiUrl + '/accountGroup',
        nominationpoints: this.apiUrl + '/nominationpoints',
    }

    constructor(http: HttpClient, localStorage: LocalStorageService, events: Events) {
        super(http, localStorage, events);
    }
}


// WEBPACK FOOTER //
// ./src/services/api.ts